import EventBase from '../EventClass/EventBase'
import CustomUIItem from './CustomUIItem'
import CustomUIGood from './CustomUIGood'
import PersonFavour from './PersonFavour'
import { FileReader, FileWriter } from '@/platform'
import Hashtable from '../Hashtable'
import { writeIntBool } from '../gameBinUtils'

enum customUIType {
    CustomUI = 0,
    Mall = 1,
    Charm = 2,
    Property = 3,
}
class CustomUIData {
    public LoadEvent: EventBase[] = [] // UI预加载的事件集合
    public ControlList: CustomUIItem[] = [] // UI控件集合
    public ShowEffect: number = 0 // UI出现和消失的效果
    public IsMouseExit: boolean = true // 是否可以鼠标右键退出
    public IsKeyExit: boolean = true // 是否可以esc键退出
    public Name: string = '' // UI的名称
    public Type: customUIType = customUIType.CustomUI // UI类型
    public VarHash: Hashtable = new Hashtable() // 预览图字段哈希表
    public StrHash: Hashtable = new Hashtable() // 预览图字符串哈希表
    public Cuigs: CustomUIGood = new CustomUIGood() // 制作商城的数据结构
    public AfterEvent: EventBase[] = [] //UI加载完毕后的事件集合
    public PsnFavour: PersonFavour = new PersonFavour() // 人物好感度数据类型

    constructor(UItype: customUIType = 0) {
        this.Type = UItype
    }

    readBin(reader: FileReader): void {
        this.LoadEvent = []
        const eventLen = reader.readInt()
        this.LoadEvent.length = eventLen
        for (var i = 0; i < eventLen; i++) {
            let event = new EventBase()
            event.readBin(reader)
            this.LoadEvent[i] = event
        }

        this.ControlList = []
        const elementLen = reader.readInt()
        this.ControlList.length = elementLen
        for (var i = 0; i < elementLen; i++) {
            let element = new CustomUIItem()
            element.readBin(reader)
            this.ControlList[i] = element
        }

        this.ShowEffect = reader.readInt()
        this.IsMouseExit = reader.readBool()
        this.IsKeyExit = reader.readBool()
        this.Name = reader.readString()
        this.Type = reader.readInt() as customUIType
        this.VarHash.readBin(reader)
        this.StrHash.readBin(reader)
        this.Cuigs.readBin(reader)

        this.AfterEvent = []
        const afterLen = reader.readInt()
        this.AfterEvent.length = afterLen
        for (var i = 0; i < afterLen; i++) {
            let event = new EventBase()
            event.readBin(reader)
            this.AfterEvent[i] = event
        }
        this.PsnFavour.readBin(reader)
    }

    // 数据写入
    writeBin(writer: FileWriter): void {
        writer.writeInt(this.LoadEvent.length)
        for (let i = 0; i < this.LoadEvent.length; i++) {
            var event = this.LoadEvent[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeBin(writer)
        }

        writer.writeInt(this.ControlList.length)
        for (let i = 0; i < this.ControlList.length; i++) {
            var control = this.ControlList[i]
            if (control instanceof CustomUIItem === false) {
                control = Object.assign(new CustomUIItem(), control)
            }
            control.writeBin(writer)
        }

        writer.writeInt(this.ShowEffect)
        writer.writeBool(this.IsMouseExit)
        writer.writeBool(this.IsKeyExit)
        writer.writeString(this.Name)
        writer.writeInt(this.Type)
        this.VarHash.writeBin(writer)
        this.StrHash.writeBin(writer)
        this.Cuigs.writeBin(writer)
        writer.writeInt(this.AfterEvent.length)
        for (let i = 0; i < this.AfterEvent.length; i++) {
            var event = this.AfterEvent[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeBin(writer)
        }
        this.PsnFavour.writeBin(writer)
    }

    readVersionedOui(reader: FileReader): void {
        this.LoadEvent = []
        const eventLen = reader.readInt()
        for (let i = 0; i < eventLen; i++) {
            let event = new EventBase()
            event.readVersionedOui(reader.readObj(reader.readInt()))
            this.LoadEvent.push(event)
        }

        this.AfterEvent = []
        const afterLen = reader.readInt()
        for (let i = 0; i < afterLen; i++) {
            let event = new EventBase()
            event.readVersionedOui(reader.readObj(reader.readInt()))
            this.AfterEvent.push(event)
        }

        this.ControlList = []
        const elementLen = reader.readInt()
        for (let i = 0; i < elementLen; i++) {
            let element = new CustomUIItem()
            element.readVersionedOui(reader.readObj(reader.readInt()))
            this.ControlList.push(element)
        }

        this.ShowEffect = reader.readInt()
        this.IsMouseExit = reader.readInt() == 1 ? true : false
        this.IsKeyExit = reader.readInt() == 1 ? true : false
        this.Name = reader.readString()
    }

    // 数据写入
    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.LoadEvent.length)
        for (let i = 0; i < this.LoadEvent.length; i++) {
            var event = this.LoadEvent[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeVersionedOui(writer)
        }

        writer.writeInt(this.AfterEvent.length)
        for (let i = 0; i < this.AfterEvent.length; i++) {
            var event = this.AfterEvent[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeVersionedOui(writer)
        }

        writer.writeInt(this.ControlList.length)
        for (let i = 0; i < this.ControlList.length; i++) {
            var control = this.ControlList[i]
            if (control instanceof CustomUIItem === false) {
                control = Object.assign(new CustomUIItem(), control)
            }
            control.writeVersionedOui(writer)
        }

        writer.writeInt(this.ShowEffect)
        writer.writeInt(this.IsMouseExit ? 1 : 0)
        writer.writeInt(this.IsKeyExit ? 1 : 0)
        writer.writeString(this.Name)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.LoadEvent.length)
        for (let i = 0; i < this.LoadEvent.length; i++) {
            const event = this.LoadEvent[i] instanceof EventBase
                ? this.LoadEvent[i]
                : Object.assign(new EventBase(), this.LoadEvent[i] as Partial<EventBase>)
            event?.writeGameBin(writer)
        }

        writer.writeInt(this.AfterEvent.length)
        for (let i = 0; i < this.AfterEvent.length; i++) {
            const event = this.AfterEvent[i] instanceof EventBase
                ? this.AfterEvent[i]
                : Object.assign(new EventBase(), this.AfterEvent[i] as Partial<EventBase>)
            event?.writeGameBin(writer)
        }

        writer.writeInt(this.ControlList.length)
        for (let i = 0; i < this.ControlList.length; i++) {
            const control = this.ControlList[i] instanceof CustomUIItem
                ? this.ControlList[i]
                : Object.assign(new CustomUIItem(), this.ControlList[i] as Partial<CustomUIItem>)
            control?.writeGameBin(writer)
        }

        writer.writeInt(this.ShowEffect)
        writeIntBool(writer, this.IsMouseExit)
        writeIntBool(writer, this.IsKeyExit)
        writer.writerLength()
    }
}

export default CustomUIData
